import React, { useEffect, useState } from 'react';
import { getWatermarkData } from '../../utils/helper';
import './style.css';
import { useCanvas } from '../../context/canvasContext';

const WaterMark = () => {
    const [watermarkData, setWatermarkData] = useState(null);
    const { userInfo } = useCanvas();

    useEffect(() => {
        let isMounted = true;
        const loadData = async () => {
            const data = await getWatermarkData();
            if (isMounted) setWatermarkData(data);
        };
        loadData();
        return () => { isMounted = false; };
    }, []);

    const {
        location = { lat: 'N/A', lng: 'N/A' },
        ip = 'N/A',
        currentDateTime = 'N/A'
    } = watermarkData || {};

    return (
        <div className="watermark-style">
            <div>User: {userInfo?.name || 'N/A'}</div>
            <div>Location: {location.lat}, {location.lng}</div>
            <div>IP: {ip}</div>
            <div>Time: {currentDateTime}</div>
        </div>
    );
};

export default WaterMark;
